import InputSelect from "../../../../components/form/inputSelect/inputSelect";
import { useState, useEffect } from "react";

const Duration = ({ duration, setDuration }) => {
    const [durationTime, setDurationTime] = useState({
        hours: duration.value !== '' ? duration.value.slice(0, duration.value.indexOf('h')) : null,
        minutes: duration.value !== '' ? duration.value.slice(duration.value.indexOf('h')+1) : null
    });

    const [error, setError] = useState(false);

    // Génération des options avec validation
    const hours = Array.from({length: 24}, (_, i) => i);
    const minutes = Array.from({length: 60}, (_, i) => i < 10 ? `0${i}` : i);

    // Fonction pour valider la durée
    const validateDuration = (hours, minutes) => {
        // Si les heures sont vides ou à 0, on exige au moins 1 minute
        // Sinon on permet les minutes à '00' (ex: 1h00 est valide)
        if (!hours || hours === 0 || hours === '0') {
            return minutes !== '00' && minutes !== '' && minutes !== null;
        }
        // Si les heures sont supérieures à 0, toutes les minutes sont valides (y compris '00')
        return true;
    };

    // Fonction pour mettre à jour la durée complète
    const updateDuration = (newHours, newMinutes) => {
        const isValid = validateDuration(newHours, newMinutes);
        setError(!isValid);

        if (isValid) {
            setDurationTime({
                hours: newHours,
                minutes: newMinutes
            });
            setDuration(`activityDuration.value`, `${newHours}h${newMinutes}`);
            setDuration(`activityDuration.error`, false);
            setDuration(`activityDuration.errorMessage`, '');
        } else {
            setDuration(`activityDuration.error`, true);
            // Message d'erreur adapté selon le contexte
            const errorMessage = (!newHours || newHours === 0 || newHours === '0') 
                ? 'La durée minimale doit être d\'au moins 1 minute quand les heures sont à 0'
                : 'La durée minimale doit être d\'au moins 1 minute';
            setDuration(`activityDuration.errorMessage`, errorMessage);
        }
    };

    // Gestionnaire pour les heures
    const handleHoursChange = (e) => {
        const newHours = e.target.value;
        updateDuration(newHours, durationTime.minutes);
    };

    // Gestionnaire pour les minutes
    const handleMinutesChange = (e) => {
        const newMinutes = e.target.value;
        updateDuration(durationTime.hours, newMinutes);
    };

    // Mise à jour quand la durée change depuis l'extérieur
    useEffect(() => {
        if(duration.value !== '' && duration.value !== null){
            const hours = duration.value.slice(0, duration.value.indexOf('h'));
            const minutes = duration.value.slice(duration.value.indexOf('h')+1);
            
            const isValid = validateDuration(hours, minutes);
            setError(!isValid);

            setDurationTime({
                hours: hours,
                minutes: minutes
            });

            if (!isValid) {
                setDuration(`activityDuration.error`, true);
                // Message d'erreur adapté selon le contexte
                const errorMessage = (!hours || hours === 0 || hours === '0') 
                    ? 'La durée minimale doit être d\'au moins 1 minute quand les heures sont à 0'
                    : 'La durée minimale doit être d\'au moins 1 minute';
                setDuration(`activityDuration.errorMessage`, errorMessage);
            }
        }
    }, [duration]);

    return(
        <div className="sidebar__form__container__row">
            <div className="sidebar__form__label">
                <p className="text-16">Durée</p>
                <p className="text-12">Définissez combien de temps dure chaque session de votre activité, en heures et minutes.</p>
            </div>
            <div className="sidebar__form__content is__content__row">
                <InputSelect
                    name={"hours"}
                    label={"Heure"}
                    options={hours.map((hour) => ({id: hour, name: hour, value: hour}))}
                    valueSelected={durationTime.hours}
                    onChange={handleHoursChange}
                    isColumn={true}
                    errorMessage={error ? ((!durationTime.hours || durationTime.hours === 0 || durationTime.hours === '0') 
                        ? 'La durée minimale doit être d\'au moins 1 minute quand les heures sont à 0'
                        : 'La durée minimale doit être d\'au moins 1 minute') : duration.errorMessage}
                    error={error || duration.error}
                />

                <InputSelect
                    name={"minutes"}
                    label={"Minute"}
                    options={minutes.map((minute) => ({id: minute, name: minute, value: minute}))}
                    valueSelected={durationTime.minutes}
                    onChange={handleMinutesChange}
                    isColumn={true}
                    errorMessage={error ? ((!durationTime.hours || durationTime.hours === 0 || durationTime.hours === '0') 
                        ? 'La durée minimale doit être d\'au moins 1 minute quand les heures sont à 0'
                        : 'La durée minimale doit être d\'au moins 1 minute') : duration.errorMessage}
                    error={error || duration.error}
                />
            </div>
        </div>
    );
}

export default Duration;